import KeyCodes from './KeyCodes';
var keys = Object.keys;
/**
 * Get the key name from a keyboard event, `keyCode`, or `which` value.
 * @param event A keyboard event like object or key code.
 */

export default function getKeyName(event) {
  var keyCode;
  var returnValue;

  if (typeof event === 'number') {
    keyCode = event;
  } else {
    keyCode = event.keyCode || event.which;
  }

  keys(KeyCodes).some(function (keyName) {
    if (KeyCodes[keyName] === keyCode) {
      returnValue = keyName;
      return true;
    }

    return false;
  });
  return returnValue;
}
//# sourceMappingURL=getKeyName.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/getKeyName.js
// module id = 662
// module chunks = 0 1